import "@esri/calcite-components/components/calcite-block";
import "@esri/calcite-components/components/calcite-notice";
import "@esri/calcite-components/components/calcite-link";
import "@esri/calcite-components/components/calcite-card";
import "@esri/calcite-components/components/calcite-input";
import "@esri/calcite-components/components/calcite-button";
import "@esri/calcite-components/components/calcite-button";
import DownloadBilding from "./DownLoadBilding.js";
import { useEffect, useState } from "react";
import { sharedDownloadQueue } from "./layerlist/DownloadsQue.js";

import texts from "../../../assets/texts/texts.js";
import Description from "../../Description.jsx";

function DownloadModel({ model }) {
  const [title, setTitle] = useState("Model");
  /*   const [activeModle, setActiveModel] = useState(false); */
  const [notice, setNotice] = useState(false);
  const clickHandler = (event) => {
    if (model) {
      new DownloadBilding(model, title);
    }
  };

  const noticeHandler = () => {
    if (notice) {
      setNotice(false);
    } else {
      setNotice(true);
    }
  };

  const changeTitleHandler = (e) => {
    setTitle(e.target.value);
  };

  const hasModel = sharedDownloadQueue.data;

  return (
    <>
      <calcite-block
        id="download"
        scale="l"
        collapsible
        heading={texts.widgets.uploadmodel.download.title}
        icon-start="download"
      >
        {!hasModel && (
          <calcite-notice open id="downloadNoticeStart" icon="information">
            <div slot="message">
              {texts.widgets.uploadmodel.download.startInfo + " "}
              <calcite-link
                slot="link"
                href={texts.widgets.uploadmodel.download.descriptionsURL}
                target="_blank"
              >
                {texts.description}: {texts.widgets.uploadmodel.download.title}
              </calcite-link>
            </div>
          </calcite-notice>
        )}
        {hasModel && (
          <calcite-card id="downloadPanel">
            <span slot="heading">
              {texts.widgets.uploadmodel.download.description.title}
            </span>
            <span slot="description">
              {texts.widgets.uploadmodel.download.description.paragraph_1}
            </span>
            <calcite-input
              value={title}
              id="downloadInput"
              placeholder={
                texts.widgets.uploadmodel.download.description.placeholder
              }
              onInput={changeTitleHandler}
            ></calcite-input>
            <calcite-notice
              open={notice}
              id="downloadNotice"
              icon="information"
              className="margin_top"
            >
              <div slot="message">
                {texts.widgets.uploadmodel.download.description.info}
              </div>
              <calcite-link
                slot="link"
                href={texts.widgets.uploadmodel.download.descriptionsURL}
                target="_blank"
              >
                {texts.description}: {texts.widgets.uploadmodel.download.title}
              </calcite-link>
            </calcite-notice>
            <div slot="footer-start" id="example-slotted-footer">
              <calcite-button
                icon-start="download"
                id="downloadButton"
                onClick={() => {
                  clickHandler();
                }}
              >
                {texts.widgets.uploadmodel.download.description.downloadbutton}
              </calcite-button>
            </div>
            <div slot="footer-end">
              <calcite-action
                scale="s"
                icon="information"
                id="downloadInfoIcon"
                onClick={noticeHandler}
              ></calcite-action>
            </div>
          </calcite-card>
        )}
      </calcite-block>
    </>
  );
}

export default DownloadModel;
